import script from "./SendPassword.vue?vue&type=script&setup=true&lang=js"
export * from "./SendPassword.vue?vue&type=script&setup=true&lang=js"

import "./SendPassword.vue?vue&type=style&index=0&id=07fea19a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07fea19a"]])

export default __exports__